export default "__VITE_ASSET__CzJoxz4V__"